import React, { useState, useEffect } from "react";
import axios from "axios";
import { Url } from "../../Component/function/FunctionApi";
import { getCookie } from "../../Pages/Login/Login";

function DeletedProjectsContent() {
  const [deletedInvoices, setDeletedInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [filters, setFilters] = useState({
    invoiceId: "",
    userName: "",
    fromDate: "",
    toDate: "",
  });

  const getToken = () => {
    const userCookie = getCookie("user");
    return userCookie ? JSON.parse(userCookie).token : null;
  };

  const buildParams = () => {
    console.log("search query", filters);
    const params = { page: currentPage, pageSize };
    if (filters.invoiceId) params.invoiceId = Number(filters.invoiceId);
    if (filters.userName) params.userName = filters.userName;
    if (filters.fromDate) params.fromDate = filters.fromDate;
    if (filters.toDate) params.toDate = filters.toDate;
    return params;
  };

  const fetchDeletedInvoices = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${Url}Invoice/invoice-history-deleted`, {
        headers: { Authorization: `Bearer ${getToken()}` },
        params: buildParams(),
      });

      if (response.data.statusCode === 200) {
        const payload = response.data;
        const items = Array.isArray(payload.data) ? payload.data : [];
        setDeletedInvoices(items);
        const pagesFromServer = payload.totalPages;
        const countFromServer = payload.totalCount;
        const computedTotalPages = pagesFromServer
          ? pagesFromServer
          : countFromServer
          ? Math.max(1, Math.ceil(countFromServer / pageSize))
          : Math.max(1, Math.ceil(items.length / pageSize));
        setTotalPages(computedTotalPages);
        if (payload.currentPage) setCurrentPage(payload.currentPage);
      } else {
        setError(response.data.message || "حدث خطأ أثناء جلب البيانات");
      }
    } catch (err) {
      setError("حدث خطأ أثناء جلب البيانات");
      console.error("Error fetching deleted invoices:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeletedInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchDeletedInvoices();
  };

  const handleClear = () => {
    setFilters({ invoiceId: "", userName: "", fromDate: "", toDate: "" });
    setCurrentPage(1);
    setPageSize(10);
    fetchDeletedInvoices();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("ar-SA", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const currentItems = deletedInvoices; // server provides paginated items

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-right">
          الفواتير المحذوفة
        </h2>

        {/* Filters */}
        <div className="bg-white rounded-lg shadow p-4 mb-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-3">
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">رقم الفاتورة</label>
              <input
                type="number"
                className="border rounded px-2 py-1"
                value={filters.invoiceId}
                onChange={(e) => {
                  console.log("e", e.target.value);
                  setFilters((f) => ({ ...f, invoiceId: e.target.value }));
                  console.log("filters", filters);
                }}
                placeholder="مثال: 12345"
              />
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">المستخدم</label>
              <input
                type="text"
                className="border rounded px-2 py-1"
                value={filters.userName}
                onChange={(e) => setFilters((f) => ({ ...f, userName: e.target.value }))}
                placeholder="اسم المستخدم"
              />
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">من تاريخ</label>
              <input
                type="datetime-local"
                className="border rounded px-2 py-1"
                value={filters.fromDate}
                onChange={(e) => setFilters((f) => ({ ...f, fromDate: e.target.value }))}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">إلى تاريخ</label>
              <input
                type="datetime-local"
                className="border rounded px-2 py-1"
                value={filters.toDate}
                onChange={(e) => setFilters((f) => ({ ...f, toDate: e.target.value }))}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">حجم الصفحة</label>
              <select
                className="border rounded px-2 py-1"
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>
            <div className="flex items-end gap-2">
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                onClick={handleSearch}
              >
                بحث
              </button>
              <button
                className="px-3 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                onClick={handleClear}
              >
                مسح
              </button>
            </div>
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
            role="alert"
          >
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        {/* Deleted Invoices List */}
        {!loading && !error && (
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      رقم الفاتورة
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      نوع العملية
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      المستخدم
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      التاريخ
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      الوصف
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {currentItems.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.invoiceId}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.actionType}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.userName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {formatDate(item.actionDate)}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900">
                        {item.changesDescription}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Pagination */}
        {!loading && !error && (
          <div className="flex flex-col items-center justify-center gap-4 py-6">
            <div className="flex items-center justify-center gap-2">
              <button
                onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-2
                  ${
                    currentPage === 1
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 hover:border-gray-400"
                  }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                السابق
              </button>

              <div className="flex items-center gap-1">
                {Array.from({ length: totalPages }, (_, index) => {
                  const pageNumber = index + 1;
                  const isNearCurrentPage = Math.abs(pageNumber - currentPage) <= 1;
                  const isFirstPage = pageNumber === 1;
                  const isLastPage = pageNumber === totalPages;

                  if (isFirstPage || isLastPage || isNearCurrentPage) {
                    return (
                      <button
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        className={`w-10 h-10 rounded-lg text-sm font-medium transition-all duration-200
                          ${
                            currentPage === pageNumber
                              ? "bg-blue-600 text-white hover:bg-blue-700"
                              : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 hover:border-gray-400"
                          }`}
                      >
                        {pageNumber}
                      </button>
                    );
                  } else if (
                    (pageNumber === 2 && currentPage > 3) ||
                    (pageNumber === totalPages - 1 && currentPage < totalPages - 2)
                  ) {
                    return (
                      <span key={pageNumber} className="px-2">
                        ...
                      </span>
                    );
                  }
                  return null;
                })}
              </div>

              <button
                onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-2
                  ${
                    currentPage === totalPages
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 hover:border-gray-400"
                  }`}
              >
                التالي
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>

            <div className="text-sm text-gray-600">
              صفحة {currentPage} من {totalPages}
            </div>
          </div>
        )}

        {/* No Results */}
        {!loading && !error && deletedInvoices.length === 0 && (
          <div className="text-center py-8 text-gray-500">لا توجد فواتير محذوفة</div>
        )}
      </div>
    </div>
  );
}

export default DeletedProjectsContent;
